import { Collapse } from 'bootstrap'
import '../scss/styles.scss'
import Rails from '@rails/ujs'

import '@fortawesome/fontawesome-free/css/all.css'

import Search from '../Search.svelte'

const app = []

async function enhancePlayerComparisonSelects () {
  const elements = document.querySelectorAll('.player-comparison-select')
  if (elements.length === 0) return

  try {
    const [{ default: TomSelect }] = await Promise.all([
      import('tom-select'),
      import('tom-select/dist/css/tom-select.bootstrap5.css')
    ])

    elements.forEach(function (element) {
      new TomSelect(element, {
        create: false,
        placeholder: element.getAttribute('placeholder'),
        searchField: ['text'],
        selectOnTab: true
      })
    })
  } catch (error) {
    console.error('Unable to enhance player comparison selects', error)
  }
}

document.addEventListener('DOMContentLoaded', function () {
  const elements = document.getElementsByClassName('search-svelte')
  for (var i = 0; i < elements.length; i++) {
    elements[i].innerHTML = ''
    const search = new Search({ target: elements[i] })
    app.push(search)
  }
  // https://github.com/rails/rails/blob/main/actionview/app/assets/javascripts/rails-ujs.js
  if (window._rails_loaded != true) {
    Rails.start()
  }

  enhancePlayerComparisonSelects()

  document.querySelectorAll('[data-analytics-view-event]').forEach(function (element) {
    if (typeof window.gtag === 'function') {
      window.gtag('event', element.dataset.analyticsViewEvent)
    }
  })

  document.addEventListener('submit', function (event) {
    const analyticsEvent = event.target.dataset.analyticsEvent
    if (analyticsEvent && typeof window.gtag === 'function') {
      window.gtag('event', analyticsEvent)
    }
  })

  document.addEventListener('click', function (event) {
    const target = event.target.closest('[data-analytics-event]')
    if (target && typeof window.gtag === 'function') {
      window.gtag('event', target.dataset.analyticsEvent)
    }
  })
})

export default app
